import {
    Heading,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import MessageField from "components/details-form/message-field";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { Control } from "react-hook-form";
import { ContactInfoForm } from "store/store-types";

interface EditMessageViewProps {
    control: Control<ContactInfoForm>;
    value?: string;
}

const EditMessageView = ({ control, value }: EditMessageViewProps) => {
    const { t } = useTranslation();

    useStepTracking({
        stepName: TrackingStepName.EditBookingMessage,
    });

    return (
        <Stack spacing={ThemeSpaceVariable.Medium}>
            <Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge}>
                {t("editBooking.addMessage")}
            </Heading>
            <MessageField control={control} value={value || ""} />
        </Stack>
    );
};

export default EditMessageView;
